import '../../styles.css';
import React from 'react';
import { NavLink } from 'react-router-dom';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";

function GeneralParams() {
  return (
    <div className="scrollable-container">
      <MyPage />
      <SubTabsGeneralParams />
    </div>
  );
}

export default GeneralParams;
